import { useCallback, useEffect, useRef, useState } from 'react'

export function useVideoPreview(initialDeviceId = '') {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const streamRef = useRef<MediaStream | null>(null)
  const [isEnabled, setEnabled] = useState(true)
  const [deviceId, setDeviceId] = useState(initialDeviceId)

  const stopPreview = useCallback(() => {
    if (streamRef.current) {
      for (const track of streamRef.current.getTracks()) {
        track.stop()
      }
      streamRef.current = null
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null
    }
  }, [])

  useEffect(() => {
    const startPreview = async () => {
      stopPreview()

      if (!isEnabled) return

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: deviceId ? { deviceId } : true,
          audio: false,
        })
        streamRef.current = stream

        if (videoRef.current) {
          videoRef.current.srcObject = stream
        }
      } catch (err) {
        console.error('Error starting video preview:', err)
      }
    }

    startPreview()
  }, [isEnabled, deviceId, stopPreview])

  useEffect(() => {
    return () => {
      stopPreview()
    }
  }, [stopPreview])

  return {
    videoRef,
    streamRef,
    isEnabled,
    setEnabled,
    deviceId,
    setDeviceId,
    stopPreview,
  }
}
